import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  return <footer className="bg-gray-800 text-gray-300" data-id="element-40">
      <div className="container mx-auto px-4 py-8" data-id="element-41">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-42">
          <div data-id="element-43">
            <h3 className="text-white font-semibold mb-4" data-id="element-44">FlightTracker</h3>
            <p className="text-sm" data-id="element-45">
              Real-time flight tracking and status alerts for commercial flights
              worldwide.
            </p>
          </div>
          <div data-id="element-46">
            <h4 className="text-white font-medium mb-4" data-id="element-47">Quick Links</h4>
            <ul className="space-y-2 text-sm" data-id="element-48">
              <li data-id="element-49">
                <Link to="/" className="hover:text-white transition-colors" data-id="element-50">
                  Home
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/search" className="hover:text-white transition-colors" data-id="element-52">
                  Search Flights
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/alerts" className="hover:text-white transition-colors" data-id="element-54">
                  Set Alerts
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/my-alerts" className="hover:text-white transition-colors" data-id="element-56">
                  My Alerts
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-57">
            <h4 className="text-white font-medium mb-4" data-id="element-58">Resources</h4>
            <ul className="space-y-2 text-sm" data-id="element-59">
              <li data-id="element-60">
                <a href="#" className="hover:text-white transition-colors" data-id="element-61">
                  Flight Status Guide
                </a>
              </li>
              <li data-id="element-62">
                <a href="#" className="hover:text-white transition-colors" data-id="element-63">
                  Airport Information
                </a>
              </li>
              <li data-id="element-64">
                <a href="#" className="hover:text-white transition-colors" data-id="element-65">
                  Airlines Directory
                </a>
              </li>
              <li data-id="element-66">
                <a href="#" className="hover:text-white transition-colors" data-id="element-67">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-68">
            <h4 className="text-white font-medium mb-4" data-id="element-69">Contact</h4>
            <ul className="space-y-2 text-sm" data-id="element-70">
              <li data-id="element-71">support@flighttracker.com</li>
              <li data-id="element-72">1-800-FLIGHTS</li>
              <li data-id="element-73">123 Aviation Way</li>
              <li data-id="element-74">San Francisco, CA 94105</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-6 text-sm text-center" data-id="element-75">
          <p data-id="element-76">
            &copy; {new Date().getFullYear()} FlightTracker. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;